export default __webpack_public_path__ + "assets/audios/d0102d5c0c3edb7247c175e6b5c25b4a.mp3";